import { useEffect, useState } from 'react';
import gapIntelligenceService from '../../../services/gapIntelligenceService';

// One request per org per page load; the answer only changes when the backend
// pilot list (GAP_INTELLIGENCE_TENANTS) changes.
const cache = {};

const useGapIntelligenceEnabled = (orgKey) => {
  const key = orgKey || 'current';
  const [enabled, setEnabled] = useState(cache[key]?.value ?? false);

  useEffect(() => {
    let alive = true;
    if (!cache[key]) {
      // A failed check (backend restarting, other branch) is not cached, so the
      // next mount asks again instead of hiding the feature until a reload.
      cache[key] = {
        promise: gapIntelligenceService.isEnabled().catch(() => {
          delete cache[key];
          return false;
        }),
      };
    }
    const entry = cache[key];
    entry.promise.then((value) => {
      entry.value = value;
      if (alive) setEnabled(value);
    });
    return () => {
      alive = false;
    };
  }, [key]);

  return enabled;
};

export default useGapIntelligenceEnabled;
